import { ComponentInfoSelectors } from './component-info/component-info.selectors';
import { ProviderSelectors } from './provider/provider.selectors';
import { RouterSelectors } from './router/router.selectors';
import { LoggedInUserSelectors } from './logged-in-user/logged-in-user.selectors';

export class SharedSelectors {
  static readonly ComponentInfo = ComponentInfoSelectors;
  static readonly Provider = ProviderSelectors;
  static readonly Router = RouterSelectors;
  static readonly LoggedInUser = LoggedInUserSelectors;
}
